import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { getRolesWithPositionEmail } from '../../core/utils/roleUtils';

function RolePositionEmailContacts({ roles, contentPaddingLeft = '23px' }) {
  const rolesWithEmail = getRolesWithPositionEmail(roles);

  if (rolesWithEmail.length === 0) {
    return null;
  }

  return (
    <>
      {rolesWithEmail.map((role) => (
        <div className="detail-info" key={role._id || role.name}>
          <span className="detail-title">
            <Icon icon="dashicons:email" className="detail-icon" />
            {role.name} email
          </span>
          <p style={{ paddingLeft: contentPaddingLeft }}>
            <a href={`mailto:${role.positionEmail}`}>{role.positionEmail}</a>
          </p>
        </div>
      ))}
    </>
  );
}

export default RolePositionEmailContacts;
